<template>
  <div>
    <NavBar />
    <div class="container">
      <SideBar />
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <h1 class="title">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"width="412.996px" height="412.996px" viewBox="0 0 412.996 412.996" style="enable-background:new 0 0 412.996 412.996;"xml:space="preserve"> <path d="M392.996,28.338H20c-11.047,0-20,8.954-20,20v234c0,11.046,8.953,20,20,20h139.498v45.32h-54.283 c-10.201,0-18.5,8.299-18.5,18.5s8.299,18.5,18.5,18.5h202.566c10.201,0,18.5-8.299,18.5-18.5s-8.299-18.5-18.5-18.5h-54.283 v-45.32h139.498c11.047,0,20-8.954,20-20v-234C412.996,37.292,404.043,28.338,392.996,28.338z M382.996,272.338H30v-214h352.996 V272.338z"/> <path d="M94.591,176.637l63.084,29.336c1.631,0.755,3.367,1.138,5.162,1.138c2.338,0,4.616-0.664,6.597-1.924 c3.548-2.267,5.666-6.13,5.666-10.335v-0.322c0-4.751-2.785-9.115-7.096-11.119l-39.455-18.33l39.456-18.334 c4.31-2.004,7.095-6.369,7.095-11.118v-0.319c0-4.211-2.119-8.074-5.665-10.334c-1.962-1.254-4.247-1.916-6.606-1.916 c-1.778,0-3.563,0.391-5.16,1.133L94.59,153.525c-4.308,2.005-7.091,6.369-7.091,11.117v0.878 C87.498,170.262,90.28,174.625,94.591,176.637z"/> <path d="M175.662,236.389c2.301,3.149,6.002,5.029,9.901,5.029h0.315c5.352,0,10.042-3.426,11.672-8.516l41.557-128.76 c1.192-3.717,0.53-7.818-1.771-10.974c-2.301-3.149-6.002-5.03-9.901-5.03h-0.314c-5.354,0-10.048,3.426-11.679,8.516 L173.88,225.425C172.698,229.145,173.364,233.242,175.662,236.389z"/> <path d="M237.896,135.628c0,4.746,2.782,9.11,7.095,11.122l39.455,18.33l-39.455,18.33c-4.311,2.004-7.096,6.368-7.096,11.119 v0.322c0,4.205,2.117,8.068,5.669,10.336c1.974,1.258,4.254,1.923,6.595,1.923c1.792,0,3.527-0.383,5.169-1.142l63.081-29.335 c4.307-2.009,7.089-6.372,7.089-11.115v-0.878c0-4.748-2.783-9.112-7.093-11.117l-63.08-29.334 c-1.591-0.739-3.373-1.131-5.152-1.131c-2.358,0-4.644,0.662-6.604,1.912c-3.554,2.264-5.673,6.127-5.673,10.338V135.628 L237.896,135.628z"/> </svg>
            Páginas
          </h1>
          <ul class="tabs">
            <li class="tab-active">
              <router-link to="/paginas">Páginas</router-link>
            </li>
          </ul>
          <div class="card">
            <div class="card-body">
              <form class="form-single" v-on:submit.prevent="onSubmit">
                <div class="row">
                  <div class="col-1-2">
                    <div class="form-group">
                      <label for="">Título</label>
                      <input type="text" class="form-control" v-model="novoTitulo">
                      <br>
                      <button class="button button-success">
                        Criar Nova Página
                      </button>
                    </div>
                  </div>
                </div>
              </form>
              <div class="row">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width: 50px;">Bloqueada</th>
                      <th>Título</th>
                      <th style="width: 100px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(i, index) in items">
                      <td style="width: 50px;">
                        <span class="label error" v-if="i.bloqueado === 1">Sim</span>
                        <span class="label" v-else>Não</span>
                      </td>
                      <td>{{ i.titulo }}</td>
                      <td class="actions">
                        <router-link :to="'/pagina/' + i._id" class="button button-primary">
                          <svg x="0px" y="0px" style="margin-top: 4px; width: 12px; height: 12px; fill: #fff;" viewBox="0 0 485.219 485.22" > <g> <path d="M467.476,146.438l-21.445,21.455L317.35,39.23l21.445-21.457c23.689-23.692,62.104-23.692,85.795,0l42.886,42.897 C491.133,84.349,491.133,122.748,467.476,146.438z M167.233,403.748c-5.922,5.922-5.922,15.513,0,21.436 c5.925,5.955,15.521,5.955,21.443,0L424.59,189.335l-21.469-21.457L167.233,403.748z M60,296.54c-5.925,5.927-5.925,15.514,0,21.44 c5.922,5.923,15.518,5.923,21.443,0L317.35,82.113L295.914,60.67L60,296.54z M338.767,103.54L102.881,339.421 c-11.845,11.822-11.815,31.041,0,42.886c11.85,11.846,31.038,11.901,42.914-0.032l235.886-235.837L338.767,103.54z M145.734,446.572c-7.253-7.262-10.749-16.465-12.05-25.948c-3.083,0.476-6.188,0.919-9.36,0.919 c-16.202,0-31.419-6.333-42.881-17.795c-11.462-11.491-17.77-26.687-17.77-42.887c0-2.954,0.443-5.833,0.859-8.703 c-9.803-1.335-18.864-5.629-25.972-12.737c-0.682-0.677-0.917-1.596-1.538-2.338L0,485.216l147.748-36.986 C147.097,447.637,146.36,447.193,145.734,446.572z"/> </g></svg>
                        </router-link>
                        &nbsp;
                        <button class="button button-error" v-on:click="onDelete(i._id)">
                          <svg style="margin-top: 4px; width: 12px; height: 12px; fill: #fff;" x="0px" y="0px" viewBox="0 0 459 459"> <g> <path d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"/> </g> </svg>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      </SideBar>
    </div>
  </div>
</template>
<script>
import { get, post, del } from '@/helpers/apiRequest'
import { customToolbar } from '@/helpers/utils'
const url = '/paginas'
const urlSingle = '/pagina'

export default {
  name: 'paginas',
  data () {
    return {
      novoTitulo: '',
      customToolbar: customToolbar(),
      loading: false,
      items: []
    }
  },
  methods: {
    onSubmit () {
      const tituloPagina = this.novoTitulo || 'Nova Página'
      this.loading = true
      post(urlSingle, { titulo: tituloPagina })
        .then(json => {
          this.loading = false
          this.novoTitulo = ''
          this.$swal({ title: 'Criado com Sucesso!', type: 'success'})
          this.items.push(json)
        })
        .catch(err => console.log('err', err))
    },
    onDelete (_id) {
      this.$swal({ title: 'Confirma Remover ?', showCancelButton: true, type: 'error', confirmButtonColor: '#d82727' })
        .then(() => {
          this.loading = true
          del(`${urlSingle}/${_id}`)
            .then(json => {
              this.items = this.items.filter(i => i._id !== _id)
              this.loading = false
            })
        }, () => {})
    }
  },
  beforeMount () {
    this.loading = true
    get(url)
      .then(json => {
        this.loading = false
        this.items = json
      })
      .catch(err => console.log('err', err))
  }
}
</script>


// WEBPACK FOOTER //
// src/views/Paginas/Paginas.vue